import { render, staticRenderFns } from "./ConfirmDriverSafe.vue?vue&type=template&id=0387b7f6&scoped=true&"
import script from "./ConfirmDriverSafe.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDriverSafe.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmDriverSafe.vue?vue&type=style&index=0&id=0387b7f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387b7f6",
  null
  
)

export default component.exports